<template>
  <section class="product-description" v-if="elfsightId">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 product-description__left">
          <div class="elfsight-widget-wrapper" id="solar-widget">
            <div :class="`elfsight-app-${elfsightId}`" data-elfsight-app-lazy />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import watchConsentMixin from 'theme/mixins/watchConsentMixin.js';

export default {
  name: 'SolarWidget',
  mixins: [watchConsentMixin],
  props: {
    elfsightId: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.enableWidget();
  },
  methods: {
    enableWidget () {
      if (!document.querySelector('script[src="https://static.elfsight.com/platform/platform.js"]')) {
        const script = document.createElement('script');
        script.src = 'https://static.elfsight.com/platform/platform.js';
        script.async = true;
        document.body.appendChild(script);
      }

      const handle = window.setInterval(() => {
        const el = this.$el.querySelector('.eapps-widget > div > a');
        if (el) {
          el.style.setProperty('display', 'none', 'important');
          window.clearInterval(handle);
        }
      }, 500);
    }
  }
};
</script>
